<style lang="less" scoped>
  .slideoutContainer {
    position: relative;
  }
  .slideout {
    display: inline-block;
    position: relative;
    width: 0;
    opacity: 0;
    z-index: -1;
    -webkit-transition: width 1s ease-in-out;
    -moz-transition: width 1s ease-in-out;
    -o-transition: width 1s ease-in-out;
    transition: width 1s ease-in-out;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    transition: opacity 1s ease-in-out;
  }
  .toggleText {
    display: inline-block;
    cursor: pointer;
    user-select: none;
    background-color: #4267b2;
    color: #FFF;
    padding: 3px;
    position: relative;
    left: -70px;
    top: 200px;

    text-align: center;
    width: 115px;
    vertical-align: top;
    /* Chrome */
    -webkit-transform: rotate(-90deg);

    /* Firefox */
    -moz-transform: rotate(-90deg);

    /* IE */
    -ms-transform: rotate(-90deg);

    /* Opera */
    -o-transform: rotate(-90deg);

    /* Internet Explorer */
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);

  }
  .slideout.open {
    z-index: 0;
    width:inherit;
    opacity: 1;
  }
</style>
<template>
  <div
    ref="slideout"
    class="slideout open"
    :class="extraClasses"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'Slideout',
    components: {

    },
    props: ['defaultOpen', 'extraClasses'],
    data () {
      return {
        isOpen: false,
        _extraClasses: []
      }
    },
    computed: {
    },
    mounted () {
      this.isOpen = false
      this._extraClasses = this.extraClasses
      if (this.defaultOpen) {
        this.$refs.slideout.classList.add('open')
        this.isOpen = true
        this.defaultOpen = true
      }
    },
    methods: {
      toggle() {
        this.$refs.slideout.classList.toggle('open')
        this.isOpen = !this.isOpen
      }
    },
  }
</script>
